import MuiBox from '@mui/material/Box';
import { styled, keyframes, css } from '@mui/material';

const CirclesContainer = styled(MuiBox) `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 124px;
  height: 124px;
  position: relative;
`;
const POSITIONS_TO_COLOR = {
    inner: 'dark',
    middle: 'main',
    outer: 'light',
};
const POSITION_TO_TIME = {
    inner: '2s',
    middle: '3s',
    outer: '1.5s',
};
const POSITION_TO_PLACEMENT = {
    inner: '0px',
    middle: '7px',
    outer: '15px',
};
const SPIN = keyframes `
  0%  { transform: rotate(0deg) }
  100% { transform: rotate(360deg) }
`;
const LINE_POSITIONS = ['inner', 'middle', 'outer'];
const getStyleByPosition = (linePosition, theme) => `
  top: ${POSITION_TO_PLACEMENT[linePosition]};
  bottom: ${POSITION_TO_PLACEMENT[linePosition]};
  left: ${POSITION_TO_PLACEMENT[linePosition]};
  right: ${POSITION_TO_PLACEMENT[linePosition]};
  border-top-color: ${theme.palette.primary[POSITIONS_TO_COLOR[linePosition]]};
`;
const Spinner = styled(MuiBox, { shouldForwardProp: prop => !['linePosition'].includes(prop) }) `
  position: absolute;
  border-radius: 50%;
  border: 3px solid transparent;
  animation: ${({ linePosition }) => css `
      ${SPIN} ${POSITION_TO_TIME[linePosition]} linear infinite;
    `};
  ${({ theme, linePosition }) => getStyleByPosition(linePosition, theme)};
`;

export { CirclesContainer, LINE_POSITIONS, Spinner };
//# sourceMappingURL=index.js.map
